import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { marked } from 'marked';

/**
 * To re-generate the credits for this application (for instance, after adding/
 * removing dependencies from package.json), run `npm run credits`.  This will
 * generate a new CREDITS.md file at the root of the project, and one should replace
 * the CREDITS.md file in the src/app/assets folder with this newly generated file.
 *
 * This could probably be automated, but I wasn't sure how to make that happen.
 *
 * JDS - 9/8/2021
 */
@Component({
    selector: 'app-credits',
    templateUrl: './credits.component.html',
    styleUrls: ['./credits.component.scss'],
    standalone: false
})
export class CreditsComponent implements OnInit {
    credits: any;

    constructor(
        private readonly _location: Location,
        private readonly _http: HttpClient
    ) {}

    ngOnInit(): void {
        this._http
            .get('assets/CREDITS.md', { responseType: 'text' })
            .subscribe((creditsText) => {
                // let renderer = new marked.Renderer();
                // renderer.link = (href: string, title: string, text: string) => {
                //     return (
                //         `<a href="${href}"` +
                //         (title ? ` title="${title}"` : '') +
                //         ` target='_blank'>${text}</a>`
                //     );
                // };
                this.credits = marked(creditsText); //, { renderer });
            });
    }

    goBack() {
        this._location.back();
    }
}
